import React from 'react';
import { Location } from 'history';
import ViewSwitcher from './ViewSwitcher';
import styles from './styles.module.scss';

export interface IStatusBarProps {
  totalLessonsCompleted: number;
  totalLessonsCompletedThisRx: number;
  lessonsThisWeek: number;
  location: Location;
  listViewRoute: string;
  chartViewRoute: string;
  showTotalLessonsAllRx?: boolean;
}

const StatusBar = ({
  totalLessonsCompleted,
  totalLessonsCompletedThisRx,
  lessonsThisWeek,
  location,
  listViewRoute,
  chartViewRoute,
  showTotalLessonsAllRx,
}: IStatusBarProps) => (
  <div data-testid="lessons-status-bar" className={styles.wrapper}>
    <div>
      {showTotalLessonsAllRx && (
        <div className={styles.header} data-testid="total-lessons-all-rx">
          <div className={styles.value}>{totalLessonsCompleted}</div>
          <div className={styles.label}>
            Total lessons
            <br />
            completed (All Rx)
          </div>
        </div>
      )}
      <div className={styles.header} data-testid="total-lessons-this-rx">
        <div className={styles.value}>{totalLessonsCompletedThisRx}</div>
        <div className={styles.label}>
          Total lessons
          <br />
          completed (Current Rx)
        </div>
      </div>
      <div className={styles.header} data-testid="total-lessons-this-week">
        <div className={styles.value}>{lessonsThisWeek}</div>
        <div className={styles.label}>
          Lessons
          <br />
          this week
        </div>
      </div>
    </div>
    <ViewSwitcher
      location={location}
      listViewRoute={listViewRoute}
      chartViewRoute={chartViewRoute}
    />
  </div>
);

export default StatusBar;
